<div class="notifications-page">
  <wf-page-tour [steps]="tourSteps"></wf-page-tour>
  <div class="header-controls">
    <h3 class="page-heading">
      <fa-icon [icon]="pageHeaderIcon" class="page-header-icon" />
      Notifications
    </h3>
    @if (mode() === 'recent') {
      <refresh-button (click)="reloadRecentNotifications()"></refresh-button>
    }
  </div>

  @if (message()) {
    <div class="alert message" [ngClass]="{ 'alert-danger': messageStatus() === 'error', 'alert-success': messageStatus() === 'success' }">
      <div class="icon">
        @if (messageStatus() === 'success') {
          <fa-icon [icon]="successIcon"></fa-icon>
        } @else if (messageStatus() === 'error') {
          <fa-icon [icon]="errorIcon"></fa-icon>
        }
      </div>
      <div>
        <div class="bold">{{ messageTitle() }}</div>
        {{ message() }}
      </div>
    </div>
  }


  <div class="notifications-card">
    <!-- Styled dynamically based on mode configuration -->
    <div [ngClass]="mode() === 'recent' ? 'recent-section-bar' : 'history-section-bar'">
      {{ mode() === 'recent' ? 'Recent' : 'History' }}
    </div>

    <div class="notifications-card-body">
      <div class="section-controls">
        <!-- History View Date Range Pickers -->
        @if (mode() === 'history') {
          <div class="date-range">
            <label>Start Date</label>
            <div class="date-input-wrapper">
              <input type="date" class="form-control date-input" [(ngModel)]="startDate" />
            </div>

            <label>End Date</label>
            <div class="date-input-wrapper">
              <input type="date" class="form-control date-input" [(ngModel)]="endDate" />
            </div>

            <button
              type="button"
              class="btn btn-filter"
              (click)="applyDateFilter()"
            >
              <fa-icon [icon]="filterIcon"></fa-icon>
              Filter
            </button>
          </div>
        }
        <input
          type="text"
          class="form-control search-input"
          placeholder="Search"
          [(ngModel)]="searchTerm"
        />
      </div>

      <div class="notifications-table-container">
        <div class="notification-section-header">
          <div class="notification-section-title">
            <fa-icon [icon]="emailIcon" class="email-icon" />
            Notifications ({{ notificationCount() }})
          </div>

          <!-- Recent View Actions Menu -->
          @if (mode() === 'recent') {
            <div class="notification-section-actions">
              <button
                type="button"
                class="btn btn-dismiss"
                [disabled]="!selectedCount() || isDismissing()"
                (click)="dismissSelected()"
              >
                @if (isDismissing()) {
                  <fa-icon [icon]="loadingIcon" [spin]="true" />
                } @else {
                  <fa-icon [icon]="dismissIcon" />
                }
                Dismiss Selected @if (selectedCount()) { ({{ selectedCount() }}) }
              </button>
              <div class="dismiss-help-text">Select History to view dismissed notifications</div>
            </div>
          }
        </div>

        <table class="report-table notifications-table">
          <thead>
          <tr>
            @if (mode() === 'recent') { <th id="select-th">Select</th> }
            <th>
              <button type="button" class="sort-btn" (click)="toggleSort()">
                Alert Date
                <fa-icon [icon]="sortAscending() ? sortUpIcon : sortDownIcon" />
              </button>
            </th>
            <th id="alert-type-th">Alert Type</th>
            <th id="alert-th">Alert</th>
            <th id="where-to-look-th">Where to look...</th>
          </tr>
          </thead>
          <tbody>
            @if (displayedNotifications().length === 0) {
              <tr>
                <td [attr.colspan]="mode() === 'recent' ? 5 : 4" class="no-data">
                  @if (searchTerm()) {
                    No notifications match your search.
                  } @else if (mode() === 'recent') {
                    No recent notifications in the past 7 days.
                  } @else {
                    No notifications
                  }
                </td>
              </tr>
            }
            @for (row of displayedNotifications(); track (row.displayDate + '_' + row.type)) {
              <tr>
                @if (mode() === 'recent') {
                  <td class="print-hide">
                    <input
                      type="checkbox"
                      [checked]="checkedGroups().has(row.displayDate + '_' + row.type)"
                      (change)="toggleGroup($event, row.displayDate + '_' + row.type)"
                    />
                  </td>
                }
                <td>{{ row.displayDate }}</td>
                <td class="alert-type-cell">
                  @if (row.category === 'celebration') {
                    <fa-icon [icon]="celebrationIcon" class="icon-celebration" />
                  } @else {
                    <fa-icon [icon]="needsAttentionIcon" class="icon-alert" />
                  }
                  {{ row.studentCount }} students
                </td>
                <td><a class="notification-link" (click)="openNotification(row.displayDate, row.type)">{{ row.text }}</a></td>
                <td>
                  <div class="where-to-look-category">{{ row.whereToLookCategory }}</div>
                  <a [routerLink]="row.whereToLookRoute" class="where-to-look-link">
                    {{ row.whereToLookLabel }}
                  </a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<dialog #notificationDialog (close)="onNotificationClosed()">
  @if (activeNotification()) {
    <ng-container *ngComponentOutlet="
      activeNotification();
      inputs: { data: activeNotificationData() }
      injector: notificationInjector
    "/>
  }
</dialog>
